module.exports = __webpack_public_path__ + "img/Trinidad-&-Tobago.bf1439e5.png";